var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDropdownArrowNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.183066 0.183066C0.427141 -0.0610219 0.822866 -0.0610219 1.06694 0.183066L5.00001 4.11612L8.93308 0.183066C9.17715 -0.0610219 9.57288 -0.0610219 9.81695 0.183066C10.061 0.427141 10.061 0.822866 9.81695 1.06694L5.44195 5.44195C5.19787 5.68603 4.80215 5.68603 4.55807 5.44195L0.183066 1.06694C-0.061022 0.822866 -0.061022 0.427141 0.183066 0.183066Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDropdownArrowNewIcon);
export default __webpack_public_path__ + "static/media/select-dropdown-arrow-new-icon.38aac6964458f0af739bcb3661d4f030.svg";
export { ForwardRef as ReactComponent };